import React from "react";
import { QuizyUrl } from "../../libs/env";
export function Savebtn(props) {
  let border_color = "border-dark";
  let color = "#000";
  if(window.location.origin.includes(QuizyUrl))
  {
    border_color = "border-darkblue";
    color = "#1C49D0";
  }
  return (
    <button
      type="button"
      class={`btn ${border_color} btn-width`}
      style={{ backgroundColor: "white", color: `${color}`, width: "100px" }}
      onClick={props.click}
      {...props}
    >
      <p style={{fontWeight:"910"}}>Save</p>
    </button>
  );
}
